module.exports = __webpack_public_path__ + "img/step05d__stand_power_bottom_cross.e27bf796.png";